var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('path',{attrs:{"d":"M13 3V9H21V3H13ZM13 21H21V11H13V21ZM3 21H11V15H3V21ZM3\n  13H11V3H3V13Z"}}),(_vm.title !== '')?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }